import useTerms, { SEATerms } from './useTerms';

export type InstantPayTerms = SEATerms[number];

const selectInstantPayTerms = (terms: SEATerms): InstantPayTerms | undefined =>
  terms.find((term) => term.kind === 'INSTANT_PAY_TERMS_AND_CONDITIONS');

/** The user's current Instant Pay terms entry, or `undefined` when none is effective. */
const useInstantPayTerms = () => useTerms(selectInstantPayTerms);

export default useInstantPayTerms;
